<script lang="ts" setup>
import { useOrganizationStore } from '@/stores/organization';

import { sidebarData } from './data/sidebar-data';
import NavFooter from './nav-footer.vue';
import NavTeam from './nav-team.vue';
import TeamSwitcher from './team-switcher.vue';

// Get reference to organization store
const organizationStore = useOrganizationStore();

// Don't proactively load user organizations
// This will now only happen in App.vue during initial app mount
// preventing duplicate API calls when navigating

// Link teams to organizations - use team.id from generated team data
function teamSelected(team: any) {
  console.log('👥 Team selected:', team);

  // Use team.id directly if it exists (from organizations), otherwise fall back to name mapping
  let orgId = null;

  if (team?.id) {
    orgId = team.id;
  } else if (team?.name === 'RingCentral') {
    orgId = 'ringcentral';
  } else if (team?.name === 'Orange Fitness') {
    orgId = 'org-id-west-harlem'; // Updated to match our mock API
  }

  console.log('🆔 Resolved orgId:', orgId);

  // Update organization in store if we have a valid ID
  if (orgId) {
    organizationStore.switchOrganization(orgId);
  } else {
    console.warn('⚠️ No valid orgId found for team:', team);
  }

  // Emit event to notify team change
  window.dispatchEvent(new CustomEvent('organization-changed', { detail: team }));
}
</script>

<template>
  <UiSidebar collapsible="icon" class="z-50">
    <UiSidebarHeader>
      <TeamSwitcher :teams="sidebarData.teams" @team-selected="teamSelected" />
    </UiSidebarHeader>

    <UiSidebarContent>
      <NavTeam :nav-main="sidebarData.navMain" />
    </UiSidebarContent>

    <UiSidebarFooter>
      <NavFooter :user="sidebarData.user" />
    </UiSidebarFooter>

    <UiSidebarRail />
  </UiSidebar>
</template>

<style></style>
